import { render, staticRenderFns } from "./TextImageMedium.vue?vue&type=template&id=4a3826d0"
import script from "./TextImageMedium.vue?vue&type=script&lang=js"
export * from "./TextImageMedium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports